import * as Sentry from "@sentry/capacitor";
import {Preferences} from "@capacitor/preferences";

const AUTO_PRINT_RECEIPTS_KEY = "autoPrintReceipts";
const HAS_RESET_AUTO_PRINT_RECEIPTS_KEY = "hasResetAutoPrintReceipts";

export async function getStoredAutoPrintReceipts() {
    try {
        const {value} = await Preferences.get({key: AUTO_PRINT_RECEIPTS_KEY});
        return value;
    } catch (err) {
        Sentry.captureException(err);
        return null; // this shouldn't happen
    }
}

export async function setStoredAutoPrintReceipts(autoPrintReceipts: boolean) {
    await Preferences.set({
        key: AUTO_PRINT_RECEIPTS_KEY,
        value: autoPrintReceipts.toString(),
    });
}

export async function getStoredHasResetAutoPrintReceipts() {
    try {
        const {value} = await Preferences.get({
            key: HAS_RESET_AUTO_PRINT_RECEIPTS_KEY,
        });
        return value;
    } catch (err) {
        Sentry.captureException(err);
        return null; // this shouldn't happen
    }
}

export async function setStoredHasResetAutoPrintReceipts(
    hasResetAutoPrintReceipts: boolean,
) {
    await Preferences.set({
        key: HAS_RESET_AUTO_PRINT_RECEIPTS_KEY,
        value: hasResetAutoPrintReceipts.toString(),
    });
}
